export const DEFAULT_BROKER_TAGS = {
  'COL Financial': 'RETAIL',
  'COL FINANCIAL': 'RETAIL',
  'CLSA': 'FOREIGN',
  'UBS': 'FOREIGN',
  'BPI Securities': 'BANK',
  'BPI SECURITIES': 'BANK',
  'BDO Securities': 'BANK',
  'BDO SECURITIES': 'BANK',
  'Macquarie': 'FOREIGN',
  'MACQUARIE': 'FOREIGN',
  'Credit Suisse': 'FOREIGN',
  'CREDIT SUISSE': 'FOREIGN',
  'JPMorgan': 'FOREIGN',
  'JPMORGAN': 'FOREIGN',
  'Goldman Sachs': 'FOREIGN',
  'GOLDMAN SACHS': 'FOREIGN',
  'Maybank ATR': 'INSTITUTIONAL',
  'MAYBANK ATR': 'INSTITUTIONAL',
  'First Metro': 'INSTITUTIONAL',
  'FIRST METRO': 'INSTITUTIONAL',
  'SB Capital': 'INSTITUTIONAL',
  'AB Capital': 'INSTITUTIONAL',
  'RCBC Securities': 'BANK',
  'PNB Securities': 'BANK',
  'Philstocks': 'RETAIL',
  'PHILSTOCKS': 'RETAIL',
  'AAA Equities': 'RETAIL',
  'Abacus Securities': 'RETAIL',
  'Regina Capital': 'RETAIL',
  'Citisec Online': 'RETAIL',
  'CITISEC': 'RETAIL',
};

export const BROKER_TYPES = ['BANK', 'INSTITUTIONAL', 'FOREIGN', 'RETAIL', 'TRADER', 'OTHER'];

export const INSTITUTIONAL_TYPES = ['BANK', 'INSTITUTIONAL', 'FOREIGN'];

export const DEFAULT_SETTINGS = {
  maxPrice: 50.0,
  minLiquidity: 0.0,
  simCapital: 500000,
  riskPerTrade: 0.01,
  maxPositions: 3,
  maxExposure: 0.4,
  stopLossPercent: 0.05,
  timeStopDays: 20,
};

export const BROKER_CSV_FIELDS = [
  { key: 'date', label: 'Date', required: true },
  { key: 'symbol', label: 'Symbol', required: true },
  { key: 'broker', label: 'Broker', required: true },
  { key: 'buyVol', label: 'Buy Volume', required: false },
  { key: 'buyAmt', label: 'Buy Amount', required: false },
  { key: 'buyAve', label: 'Buy Average', required: false },
  { key: 'sellVol', label: 'Sell Volume', required: false },
  { key: 'sellAmt', label: 'Sell Amount', required: false },
  { key: 'sellAve', label: 'Sell Average', required: false },
  { key: 'netAmt', label: 'Net Amount', required: false },
  { key: 'totalValue', label: 'Total Value', required: false },
];

export const PRICE_CSV_FIELDS = [
  { key: 'date', label: 'Date', required: true },
  { key: 'symbol', label: 'Symbol', required: true },
  { key: 'open', label: 'Open', required: false },
  { key: 'high', label: 'High', required: false },
  { key: 'low', label: 'Low', required: false },
  { key: 'close', label: 'Close', required: true },
  { key: 'volume', label: 'Volume', required: false },
  { key: 'value', label: 'Value', required: false },
];

export const STAGE_COLORS = {
  CONFIRMED: { bg: 'bg-trading-green/15', text: 'text-trading-green', border: 'border-trading-green/30' },
  BUILD: { bg: 'bg-trading-blue/15', text: 'text-trading-blue', border: 'border-trading-blue/30' },
  EARLY: { bg: 'bg-trading-amber/15', text: 'text-trading-amber', border: 'border-trading-amber/30' },
  WATCH: { bg: 'bg-trading-muted/15', text: 'text-trading-muted', border: 'border-trading-muted/30' },
  NONE: { bg: 'bg-trading-elevated', text: 'text-trading-muted', border: 'border-trading-border' },
};

export const EXIT_COLORS = {
  CONFIRMED: { bg: 'bg-trading-red/15', text: 'text-trading-red', border: 'border-trading-red/30' },
  WARNING: { bg: 'bg-trading-amber/15', text: 'text-trading-amber', border: 'border-trading-amber/30' },
  FORCED_EXIT: { bg: 'bg-trading-red/20', text: 'text-trading-red', border: 'border-trading-red/40' },
  NONE: { bg: 'bg-trading-elevated', text: 'text-trading-muted', border: 'border-trading-border' },
};

export const ALIGNMENT_COLORS = {
  ALIGN: { text: 'text-trading-green' },
  DIVERGE: { text: 'text-trading-amber' },
  CONFLICT: { text: 'text-trading-red' },
};
